function eventListners() {
  document.querySelector(".sort-by-text").addEventListener("click", (event) => {
    document.querySelector(".sort-by-options").classList.toggle("active");
  });

    document.querySelector(".mobile-facets__open-wrapper").addEventListener("keypress", function(e) {
      var code = e.which;
        if ((code === 13) || (code === 32)) {
          document.querySelector(".toolbar").classList.add('extra-index')
        }
    });  
  
  document.querySelector(".mobile-facets__close--no-js").addEventListener("click", (event) => {
    document.querySelector(".mobile-facets__wrapper > details").removeAttribute("open")
    document.querySelector(".toolbar").style.position = "sticky";
    document.querySelector("body").classList.remove("overflow-hidden-mobile");
  });

  document.querySelector(".mobile-facets__close--no-js").addEventListener("keypress", (event) => {
    var code = event.which;

    if ((code === 13) || (code === 32)) {
      document.querySelector(".mobile-facets__wrapper > details").removeAttribute("open")
      document.querySelector(".toolbar").style.position = "sticky";
      document.querySelector("body").classList.remove("overflow-hidden-mobile");
    }
  });
  
  
  document.querySelectorAll(".clp-grid").forEach((item) => {
    item.addEventListener("click", (event) => {
      //handle click
      if(window.innerWidth < 768) {
        localStorage.setItem("grid-mobile", item.getAttribute("data-grid-type"));
      }
      else {
        localStorage.setItem("grid", item.getAttribute("data-grid-type"));
      }
      window.updateGrid(item.classList.value);
    });
  });
  // toolbar selected state
  let currentUrlString = window.location.href;
      currentUrl = new URL(currentUrlString);
  if(currentUrlString.includes("sort_by")){
    let sortByValue = currentUrl.searchParams.get("sort_by");
    document.querySelector(".sort-by-custom .sort-by-options .selected").classList.remove("selected")
      document.querySelectorAll(".sort-by-custom .sort-by-options span").forEach((item) => {
        if(item.getAttribute("value") == sortByValue) {
            item.classList.add("selected")
        }
      })
  }
}
document.querySelectorAll(".sort-by-custom .sort-by-options span").forEach((item) => {
  item.addEventListener("keypress", function(e) {
    var code = e.which;
      if ((code === 13) || (code === 32)) {
          item.click();
      }
  });  
})

document.addEventListener(
  "DOMContentLoaded",
  function () {
    // do something here ...
    eventListners();
      if(window.innerWidth < 768) {
        window.updateGrid(localStorage.getItem("grid-mobile")) ? window.updateGrid(localStorage.getItem("grid-mobile")) : ""
      }
      else {
        window.updateGrid(localStorage.getItem("grid")) ? window.updateGrid(localStorage.getItem("grid")) : ""
      }
  }
);
setGridCLP();
window.onresize = setGridCLP();

function setGridCLP(){
  window["updateGrid"] = function (gridType) {
    document.querySelectorAll(".clp-grid").forEach((element) => {
      element.classList.remove('active');
    });
    if(window.innerWidth < 768) {
       if (gridType?.includes("multiple-grid")) {
        document.querySelector(".single-grid").classList.add("active");
        document.querySelector(".main-grid").classList.remove("single-grid");
      }
      else {
        document.querySelector(".multiple-grid").classList.add("active");
        document.querySelector(".main-grid").classList.add("single-grid");
      }
    }
    else {
    if (gridType?.includes("four-grid")) {
      document.querySelector(".three-grid").classList.add("active");
      document.querySelector(".main-grid").classList.add("four-grid");
    } 
    else {
      document.querySelector(".four-grid").classList.add("active");
      document.querySelector(".main-grid").classList.remove("four-grid");
    }
    }
  };
}

function setReviewsStyle() {
  const observer = new MutationObserver((mutationsList, observer) => {

    const svgElements = document.querySelectorAll(".bv_stars_svg_no_wrap svg");
    const textElements = document.querySelectorAll(".bv_text");

    if (svgElements.length === 0) {
          console.error("No Review elements with the specified class found");
          return;
    }
    if (svgElements.length > 0) {
      console.log("Review elements rendered");
      // If the elements are found, disconnect the observer
      observer.disconnect();
      
      // Loop through each SVG element and set its properties
      svgElements.forEach((svg) => {
        svg.setAttribute("width", "16px");
        svg.setAttribute("height", "16px");
        svg.style.width = "";
        svg.style.height = "";
      });
      // Loop through each Text element and set its properties
      textElements.forEach((text) => {
        text.style.cssText = "font-size: 14px !important;";
      });
    }
  });

  // Start observing changes in the DOM
  observer.observe(document, { subtree: true, childList: true });
}

setReviewsStyle();
